import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';


import {BaseService} from '../base/base.service';
import {ItemGroup} from '../../models/lookups/item-group';
import {Query} from '../../models/query/query';
import {WebMethodResult} from '../../models/web-method-result';
import {AppModulePath} from '../../models/app-module-path';
import {HttpClient} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class ItemGroupService extends BaseService {
  private listUrl = '/api/itemgroup/list';
  private postUrl = '/api/itemgroup/save';
  private deleteUrl = '/api/itemgroup/delete/';

  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation) {
    super(injector, http2, platformLocation);
  }

  list(qry: Query): Observable<ItemGroup[]> {
    const url = this.listUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<ItemGroup[]>(url, AppModulePath.ITEM_GROUP).pipe(
      map(res => res.map(obj => new ItemGroup(obj))),
      catchError(this.handleError));
  }

  listById(qry: Query): Observable<ItemGroup> {
    const url = this.listUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<ItemGroup>(url, AppModulePath.ITEM_GROUP).pipe(
      map(res => new ItemGroup(res)),
      catchError(this.handleError));
  }

  save(itemGroup: ItemGroup): Observable<ItemGroup> {
    return this.post<ItemGroup>(this.postUrl, AppModulePath.ITEM_GROUP, itemGroup).pipe(
      map(res => new ItemGroup(res)),
      catchError(this.handleError));
  }

  delete(id: number): Observable<WebMethodResult> {
    return this._delete<WebMethodResult>(this.deleteUrl + id, AppModulePath.ITEM_GROUP).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }
}
